"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pubSubFeatureService = void 0;
__exportStar(require("./v1"), exports);
const v1_1 = require("./v1");
const featureService = new v1_1.PubSubFeatureServiceV1();
exports.pubSubFeatureService = {
    id: 'pubsub-service',
    create: () => {
        return {
            '1.0.0': () => ({
                featureService,
            }),
        };
    },
};
//# sourceMappingURL=index.js.map